import ComsobaseCourseHero from "./components/hero/index.vue";
import ComsobaseCourseActions from "./components/actions/index.vue";
import ComsobaseCourseInfo from "./components/info/index.vue";
import ComsobaseCourseCourseTitle from "./components/course-title/index.vue";
import ComsobaseCourseBlock from "./components/block/index.vue";
import SimpleBreadcrumbs from "@/modules/pages/components/simple-breadcrumbs/index.vue";
import { mapActions, mapGetters } from "vuex";
import { globalLoader } from "../../../helpers/variables";

export default {
    name: "CosmobaseStudyPage",
    props: {},
    emits: [],
    components: {
      ComsobaseCourseBlock,
      ComsobaseCourseCourseTitle,
      ComsobaseCourseHero,
      ComsobaseCourseActions,
      ComsobaseCourseInfo,
      SimpleBreadcrumbs
    },
    setup() {},
    data() {
        return {}
    },
    async created() {
      globalLoader(true)
      await Promise.all([
        this.getWebinarsById(this.$route.params?.id)
      ])
      globalLoader(false)
    },
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "cosmobase/webinar"
      })
    },
    methods: {
      ...mapActions({
        getWebinarsById: "cosmobase/GET_WEBINARS_BY_ID"
      })
    }
}
